export const FLOWTRACE_DEMO_APP_ID = "flowtrace-demo";
export const FLOWTRACE_DASHBOARD_ORIGIN = "https://flowtrace.nex-a.net";
export const FLOWTRACE_DEMO_RELEASE = "flowtrace-demo@0.1.0";
export const FLOWTRACE_INGEST_ENDPOINT =
  "https://trace-ingest.nex-a.net/api/ingest";

const localDashboardHosts = new Set(["localhost", "127.0.0.1", "[::1]"]);

export const resolveDemoIngestEndpoint = (hostname: string): string =>
  localDashboardHosts.has(hostname) ? "/api/ingest" : FLOWTRACE_INGEST_ENDPOINT;

export const demoReplayPath = (sessionId: string): string =>
  `/sessions/${FLOWTRACE_DEMO_APP_ID}/${encodeURIComponent(sessionId)}`;
